/**
 * main.js
 *
 * @package Chiellini
 */

import axios from 'axios';
import Cookies from 'js-cookie';
import ScrollHint from 'scroll-hint';

//file
//-----------------------------
window.addEventListener("load",function(){
  const file = document.querySelectorAll(".js-file");
  const fileNumLimit = 3;
  const fileSizeLimit = 1024 * 1024 * 5;

  function changeFile(e) {
    fileName = event.target.parentNode.nextElementSibling;

    const files = event.target.files;
    const fileNames = [];
    if (files.length > fileNumLimit) {
      fileName.textContent = '選択可能なファイル数は'+ fileNumLimit +'つまでです。';
      return;
    }
    for (let i = 0; i < files.length; i++) {
      if(files[i].size > fileSizeLimit) {
        fileName.textContent = 'ファイルサイズは5MB以下にしてください';
        file.value = '';
        return;
      }
      fileNames.push(files[i].name);
    }
    const fileNamesList = fileNames.join('\n');
    fileName.textContent = fileNamesList ? fileNamesList : '';
  };

  for (let i = 0; i < file.length; i++) {
    // パスワード切替ボタンをクリック
    file[i].addEventListener('change', changeFile);
  }
});

//password
//-----------------------------
window.addEventListener("load",function(){
  const passwordSwicher = document.querySelectorAll(".js-password-switcher");
  function changeInputType(e) {
    const input = e.target.previousElementSibling;
    if (input.type === "text") {
      input.type = "password";
      e.target.classList.remove('is-show');
    } else {
      input.type = "text";
      e.target.classList.add('is-show');
    }
  }
  for (let i = 0; i < passwordSwicher.length; i++) {
    // パスワード切替ボタンをクリック
    passwordSwicher[i].addEventListener('click', changeInputType);
  }
});

// checkbox
//-----------------------------
window.addEventListener("load",function(){
  //「全て選択」のチェックボックス
  const checkAll = document.querySelectorAll('.js-check-all');
  //チェックボックス
  const checkbox = document.querySelectorAll('.js-check-item');

  //「全て選択」のチェックボックスをクリックした時
  function funcCheckAll(target) {
    const item = target.closest('.js-check-group').querySelectorAll('.js-check-item');
    for (let i = 0; i < item.length; i++) {
        item[i].checked = target.checked;
    }
  }
  for (let i = 0; i < checkAll.length; i++) {
    checkAll[i].addEventListener('click', () => {
      funcCheckAll(checkAll[i]);
    },false);
  }

  //「全て選択」以外のチェックボックスをクリックした時
  function funcCheck(e){
    let count = 0;

    if(e.target.classList.contains('js-check-all') === false) {
      const item = e.target.closest('.js-check-group').querySelectorAll('.js-check-item');
      const all = e.target.closest('.js-check-group').querySelector('.js-check-all')

      for (let i = 0; i < item.length; i++) {
          if (item[i].checked) {
              count += 1;
          }
      }

      if (item.length === count) {
          all.checked = true;
      } else {
          all.checked = false;
      }
    }
  }
  for (let i = 0; i < checkbox.length; i++) {
    checkbox[i].addEventListener('click', funcCheck);
  }
});

// placeholer
//-----------------------------
function switchPlaceholder() {
  const target = document.querySelectorAll('.js-switch-placeholder');

  for (let i = 0; i < target.length; i++) {
    if (window.matchMedia('(max-width: 767px)').matches) {
      target[i].placeholder = target[i].dataset.placeholderSp;
    } else if (window.matchMedia('(min-width:768px)').matches) {
      target[i].placeholder = target[i].dataset.placeholderPc;
    }
  }
}
window.addEventListener('load', switchPlaceholder)
window.addEventListener('resize', switchPlaceholder)

// smooth scroll
//-----------------------------
window.addEventListener('DOMContentLoaded', () => {
  const anchors = document.querySelectorAll('a[href^="#"]');
  const header = document.querySelector('header').offsetHeight;
  const urlHash = location.hash;

  for ( let i = 0; i < anchors.length; i++ ) {
    anchors[i].addEventListener('click', (e) => {
      e.preventDefault();

      const href= anchors[i].getAttribute("href");

      // topに戻る以外のアンカー
      if (href !== '#top') {
        const target = document.getElementById(href.replace('#', ''));
        const position = window.pageYOffset + target.getBoundingClientRect().top - header;
        window.scroll({
          top: position,
          behavior: 'smooth'
        });

      // topに戻る
      } else {
        window.scroll({
          top: 0,
          behavior: 'smooth'
        });
      }
    });
  }
});

// gnavi
//-----------------------------
window.addEventListener('DOMContentLoaded', () => {
  const body = document.querySelector('body');
  const gnavi = document.querySelector('.js-gnavi');
  const open = document.querySelector('.js-open-gnavi');
  const close = document.querySelector('.js-close-gnavi');

  open.addEventListener('click', (e) => {
    e.preventDefault();
    gnavi.classList.add('is-open');
    body.classList.add('nav-open');
  });
  close.addEventListener('click', (e) => {
    gnavi.classList.remove('is-open');
    body.classList.remove('nav-open');
  });
});

// scrollhint
//-----------------------------
window.addEventListener('DOMContentLoaded', () => {
  if(typeof ScrollHint !== 'undefined') {
    new ScrollHint('.js-scrollable');
  }
});

// textarea resize
//-----------------------------
window.addEventListener("DOMContentLoaded", () => {
  // textareaタグを全て取得
  const textareaEls = document.querySelectorAll(".js-textarea-resize");

  textareaEls.forEach((textareaEl) => {
    // デフォルト値としてスタイル属性を付与
    textareaEl.setAttribute("style", `height: ${textareaEl.scrollHeight}px;`);
    // inputイベントが発生するたびに関数呼び出し
    textareaEl.addEventListener("input", setTextareaHeight);
  });

  // textareaの高さを計算して指定
  function setTextareaHeight() {
    this.style.height = "auto";
    this.style.height = `${this.scrollHeight}px`;
  }
});

// tip
//-----------------------------
window.addEventListener("DOMContentLoaded", () => {
  const tips_btn = document.querySelectorAll('.js-tip-open');
  const tips_content = document.querySelectorAll('.js-tip-contents');
  const tips_close = document.querySelectorAll('.js-tip-close');

  for (let i = 0; i < tips_btn.length; i++) {
    // ボタンにhoverした時
    tips_btn[i].addEventListener('mouseover', () => {
      tips_content[i].classList.add('is-open');
    }, false);

    // ボタンから離れた時
    tips_btn[i].addEventListener('mouseleave', () => {
      tips_content[i].classList.remove('is-open');
    }, false);

    //closeボタン押下
    tips_close[i].addEventListener('click', () => {
      tips_content[i].classList.remove('is-open');
    }, false);
  }
});

// modal
//-----------------------------
window.addEventListener('DOMContentLoaded', () => {
  // body要素を取得
  const body = document.getElementsByTagName('body')[0];
  // Modal Openボタンを取得
  const btn = document.querySelectorAll('.js-modal-open');
  // モーダルの背景を取得
  const modalBack = document.querySelector('.js-modal');
  // モーダルを取得
  const modal = document.querySelectorAll('.js-modal-contents');
  // ✕ボタンを取得
  const closeBtn = document.querySelectorAll('.js-modal-close');

  // イベントを付加
  // モーダルを表示
  function addOpen(e) {
    e.preventDefault();
    body.classList.add('is-open');
    modalBack.classList.add('is-open');
    document.getElementById(e.target.dataset.modal).classList.add('is-open');
  }
  for (let i = 0; i < btn.length; i++) {
    // ボタンをクリック
    btn[i].addEventListener('click', addOpen);
  }
  // モーダルを閉じる
  function addClose(e) {
    body.classList.remove('is-open');
    modalBack.classList.remove('is-open');
    for (let i = 0; i < modal.length; i++) {
      modal[i].classList.remove('is-open');
    }
  }
  for (let i = 0; i < closeBtn.length; i++) {
    //✕ボタンクリック
    closeBtn[i].addEventListener('click', addClose);
  }
  // モーダルを閉じる
  if(modalBack !== null) {
    modalBack.addEventListener('click', (event) => {
      if(event.target.closest('.js-modal-inner') === null) {
        body.classList.remove('is-open');
        modalBack.classList.remove('is-open');
        for (let i = 0; i < modal.length; i++) {
          modal[i].classList.remove('is-open');
        }
      }
    });
  }
});

// Sidebar Accordion
//-----------------------------
window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(".p-blog-tag__list--mask > a").forEach(function(element) {
    element.addEventListener("click", function(event) {
      event.preventDefault();
      var parentP = this.parentNode;
      var sectionUl = this.closest("section").querySelector("ul");
      var spanElement = this.querySelector("span");

      parentP.classList.toggle("expanded");
      sectionUl.classList.toggle("expanded");

      if (parentP.classList.contains("expanded")) {
        spanElement.textContent = "\u25b2 最小化する";
      } else {
        spanElement.textContent = "\u25bc もっと見る";
      }
    });
  });
});

// Return button
//----------------------------
document.addEventListener("DOMContentLoaded", function() {
  const windowHeight = document.documentElement.clientHeight;
  // Turnover
  window.addEventListener("scroll", function(e) {
    if(window.scrollY > windowHeight) {
      document.querySelector(".l-footer__return").classList.add("show");
    } else {
      document.querySelector(".l-footer__return").classList.remove("show");
    }
  });
});

// Get Service authorization via API
//----------------------------------
/*
window.addEventListener('DOMContentLoaded', () => {

  const baseUrl = (switcher.env == 'local') ? 'http://localhost:10104' : switcher.root_url;
  const axiosInstance = axios.create({ withCredentials: true });

  // Get auth from the service & Put auth to self
  const auth = () => {
    axiosInstance.get(`${baseUrl}/sanctum/csrf-cookie`).then(() => {
      const token = Cookies.get('XSRF-TOKEN');
      axiosInstance.post(`${baseUrl}/api/user`, {}, {
        headers: {
          'X-XSRF-TOKEN': token
        }
      }).then(({ data }) => {
        axios.get(switcher.ajax_url, {
          params: {
            'action': 'service_auth_sync',
            'user': data
          }
        }).then(({ data }) => {
          if (data.reload !== false) {
            location.reload();
          }
        });
      })
    }).catch(e => {
      //console.log(e);
    });
  };
  // Pollong (ain't it unnecessary?)
  setInterval(() => {
    auth();
  }, 30000);
  // Constructor
  auth();
});
*/
